

















































































































import Vue, { PropOptions } from "vue";

import StepAudience from "@/components/campaign/StepAudience.vue";
import StepScheduling from "@/components/campaign/StepScheduling.vue";
import StepReply from "@/components/campaign/StepReply.vue";
import StepBasicInfo from "@/components/campaign/StepBasicInfo.vue";
import ModalCampaignTest from "@/components/campaign/ModalCampaignTest.vue";
import { Campaign, CampaignAudienceType } from "@/models";
import { validateCampaignSteps } from "@/rules/campaign.rules";

export default Vue.extend({
  props: {
    campaign: Object as PropOptions<Campaign>,
  },
  components: {
    StepAudience,
    StepScheduling,
    StepReply,
    StepBasicInfo,
    ModalCampaignTest,
  },
  data() {
    return {
      e6: 1,
      basicInfoErrorMessage: true,
      audienceErrorMessage: true,
      scheduleErrorMessage: true,
      replyErrorMessage: true,
      showModalTest: false,
      tab: 0,
    };
  },
  mounted() {
    if (this.campaign) {
      this.applyRulesToSteppers(this.campaign);
    }
  },
  methods: {
    applyRulesToSteppers(campaign: Campaign) {
      const {
        basicInfoErrorMessage,
        audienceErrorMessage,
        scheduleErrorMessage,
        replyErrorMessage,
      } = validateCampaignSteps(campaign);
      this.basicInfoErrorMessage = basicInfoErrorMessage;
      this.audienceErrorMessage = audienceErrorMessage;
      this.scheduleErrorMessage = scheduleErrorMessage;
      this.replyErrorMessage = replyErrorMessage;
    },
    setSMSmethod() {
      const newTabValue =
        this.campaign.audienceType === CampaignAudienceType.List ? 1 : 0;
      if (newTabValue === 0) {
        this.campaign.audienceCustomerList = [];
      } else {
        this.campaign.audienceFileTokenMapping = [];
        window.localStorage.removeItem("@csv-array");
      }
    },
    onTest() {
      this.showModalTest = true;
    },
    onCloseTest() {
      this.showModalTest = false;
    },
    formatField(field: string) {
      switch (field) {
        case "title":
          return "Título";
        case "textMessage":
          return "Mensagem";
        case "audienceFile":
          return "Arquivo de audiência";
        case "audienceCustomerList":
          return "Lista de telefones";
        case "audienceCustomerList.phoneCountryCode":
          return "Código do país";
        case "audienceCustomerList.phoneAreaCode":
          return "Código de área";
        case "audienceCustomerList.phoneNumber":
          return "Número de telefone";
        case "audienceCustomerList.tokens.name":
          return "Nome do token";
        case "audienceCustomerList.tokens.value":
          return "Valor do token";
        case "audienceFileTokenMapping.fileColumn":
          return "Coluna";
        case "audienceFileTokenMapping.token":
          return "Token";
        case "rateLimit.volume":
          return "Volume";
        case "rateLimit.unit":
          return "Período";
        case "scheduledTo.iso":
          return "Data de agendamento";
        case "routeReplies.untilDate":
          return "Duração";
        case "routeReplies.objectId":
          return "Time";
      }
    },
  },
  watch: {
    campaign: {
      deep: true,
      handler(val) {
        if (val) {
          this.applyRulesToSteppers(val);
        }
        return;
      },
    },
  },
});
